<template>
  <div>
    <a-modal v-model:visible="visible" title="新增客户" @ok="handleOk" okText="新增" cancelText="取消" :afterClose="closeModal" width="30vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="名称" required>
          <a-input v-model:value="inputs.name" />
        </a-form-item>
        <a-form-item label="手机号" required>
          <a-input v-model:value="inputs.mobile" />
        </a-form-item>
        <a-form-item label="性别">
          <a-select v-model:value="inputs.gender" allowClear>
            <a-select-option value="男">男</a-select-option>
            <a-select-option value="女">女</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="生日">
          <a-date-picker v-model:value="inputs.birthday" placeholder="" />
        </a-form-item>
      </a-form>

    </a-modal>
  </div>
</template>

<script>
import { reactive } from "vue";
import { AddCustomer as Add } from "/src/api/todayConsultation.js";
import medicineSelector from '/src/components/selector/medicineSelector.vue';
export default {
  components: {
    medicineSelector
  },
  data() {
    return {
      visible: this.modelValue,
      medicine: "",
      inputs: {
        name: undefined,
        mobile: undefined,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    }
  },
  computed: {

  },
  methods: {

    async handleOk() {
      if (!this.inputs.name || !this.inputs.mobile) {
        this.$message.error("请填写必填项", function () { });
        return
      }
      let _this = this;

      let res = await Add(this.inputs)
      if (res.errCode == 0) {
        _this.$message.success("客户已新增", function () { });
        // _this.visible = false
        this.$emit('selectCustomer', res.data);
        this.closeModal()
        this.data = {
          name: undefined,
          mobile: undefined,
          gender: undefined,
          birthday: undefined,
        }
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    }
    //初始化data所有数据，并关闭modal
  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
